import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useActions } from "@/context/ActionsContext";
import { useAuth } from "@/context/AuthContext";
import { DOCK } from "./nav";

export function useDockAction() {
  const navigate = useNavigate();
  const { ouvrir } = useActions();
  const { user } = useAuth();
  return (code) => {
    if (["rechercher", "nouvelle_fiche", "importer"].includes(code)) return ouvrir(code === "rechercher" ? "recherche" : code);
    if (code === "favoris") return navigate("/fiches?favoris=1");
    if (code === "appels" && user?.navigation?.onglets.includes("appels")) return navigate("/focus");
    if (DOCK[code]?.path) return navigate(DOCK[code].path);
    toast("Bientôt disponible", { description: `« ${DOCK[code]?.label} » arrive dans un prochain lot.` });
  };
}

export function ouvrirMicro(detail) {
  window.dispatchEvent(new CustomEvent("assistant:ouvrir", { detail: detail?.ficheId || detail?.processusId || detail?.ecoute ? detail : null }));
}
